export enum OfferVisibilityFor {
  INFLUENCER = 'FOR_INFLUENCER',
  ADMIN_SANZARU = 'FOR_SUPER_INFLUENCER',
  DESIGNER = 'FOR_DESIGNER',
  ARCHITECT = 'FOR_ARCHITECT',
  CONTRACTOR = 'FOR_CONTRACTOR',
  DEVELOPER = 'FOR_DEVELOPER',
  EMPLOYEE_INFLUENCER = 'FOR_EMPLOYEE_INFLUENCER',
}
